import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { faCheck } from "@fortawesome/pro-regular-svg-icons";

import { Icon } from "@/components";

/** Inline row of plan-agnostic benefits shown above the plan cards. */
export const UniversalBenefits: FunctionComponent = () => {
	const { t } = useTranslation();

	const items = [
		t("usage.subscription.checkout.universals.users"),
		t("usage.subscription.checkout.universals.lists"),
		t("usage.subscription.checkout.universals.trackers"),
		t("usage.subscription.checkout.universals.campaigns"),
	];

	return (
		<div className="flex flex-wrap items-center justify-center gap-x-7 gap-y-3 mb-7">
			{items.map((item) => (
				<div key={item} className="flex items-center gap-2 text-sm font-medium text-text-meta">
					<span className="flex items-center justify-center w-[22px] h-[22px] rounded-full bg-subscription-benefit-tint text-blue-action">
						<Icon className="w-3 h-3" icon={faCheck} />
					</span>
					{item}
				</div>
			))}
		</div>
	);
};
